// Example: src/data/hire-javascript-data.js

export const hireJavascriptPageContentArabic = {
  // Helmet Content
  helmet: {
    title: "وظّف مطوري JavaScript | خدمات تطوير JavaScript",
    description: "وظّف مطوري جافا سكريبت المحترفين لتطبيقات الويب الديناميكية والمتجاوبة. خدمات جافا سكريبت المتخصصة المصممة لتناسب أهداف مشروعك.",
  },

  // Main Banner Content
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/hire-javascript.avif)`,
    image: "", // يُحتفظ به إذا كان مطلوبًا بشكل صريح، وإلا يمكن إزالته
    mainHeading: "وظّف مطوري جافا سكريبت",
    content: "هل تبحث عن مطوري جافا سكريبت ذوي المهارات العالية؟ تقدم Bitsclan أفضل مطوري جافا سكريبت عن بعد، مثاليين للشركات الناشئة والمؤسسات التي تبحث عن حلول ويب عالية الأداء.",
    btnText: "استشر مطوري جافا سكريبت لدينا",
    bannerList: [
      { list: "خيارات توظيف مرنة" },
      { list: "وظائف بدوام كامل" },
      { list: "فرق عالمية" },
    ],
  },

  // JavaScript Expertise Section
  jsExpertise: {
    btnText: "حدد موعدًا لإجراء مكالمة اليوم",
    heading: "خبرة مطوري جافا سكريبت لدينا",
    description: "في Bitsclan، يتخصص مطورو جافا سكريبت لدينا في بناء تطبيقات ويب ديناميكية، قابلة للتطوير، وعالية الأداء. نحن نضمن وظائف سلسة، تجارب مستخدم سلسة، وحلولًا متطورة لأعمالك.",
    servicesData: [
      {
        title: "استشارات جافا سكريبت",
        description: "هل تحتاج إلى إرشادات خبراء لمشروع جافا سكريبت الخاص بك؟ يقدم مطورونا ذوو الخبرة مشورة استراتيجية لتعزيز الأداء، قابلية التوسع، والكفاءة، مما يضمن تحقيق أهداف عملك.",
        icon: "/images/hire-page-icons/hire-javascrip-icon1.svg",
      },
      {
        title: "تطوير الويب بجافا سكريبت",
        description: " نحن متخصصون في بناء تطبيقات ويب قوية، غنية بالميزات، وقابلة للتطوير باستخدام جافا سكريبت. يضمن خبراؤنا أداءً سلسًا، وظائف محسّنة، وتجربة مستخدم متميزة.",
        icon: "/images/hire-page-icons/hire-javascrip-icon2.svg",
      },
      {
        title: "تطوير واجهة برمجة التطبيقات (API) بجافا سكريبت",
        description: "يبني مطورو جافا سكريبت لدينا واجهات برمجة تطبيقات قوية وآمنة، مما يتيح التكامل السلس والتواصل بين التطبيقات، الخدمات الخارجية، والمنصات.",
        icon: "/images/hire-page-icons/hire-javascrip-icon3.svg",
      },
      {
        title: "تطوير أنظمة إدارة المحتوى (CMS) والبوابات بجافا سكريبت",
        description: "هل تبحث عن نظام إدارة محتوى (CMS) قوي أو بوابة ويب؟ يبني مطورو جافا سكريبت لدينا أنظمة إدارة محتوى قابلة للتطوير وسهلة الاستخدام تبسط إدارة المحتوى وتفاعلات المستخدم.",
        icon: "/images/hire-page-icons/hire-javascrip-icon4.svg",
      },
      {
        title: "الترحيل إلى جافا سكريبت",
        description: "هل تخطط لترحيل نظامك الحالي إلى جافا سكريبت؟ يضمن خبراؤنا انتقالًا سلسًا بأقل وقت تعطل، مما يعزز الأداء وقابلية التوسع.",
        icon: "/images/hire-page-icons/hire-javascrip-icon5.svg",
      },
      {
        title: "التكامل مع الحلول الحالية",
        description: "يقوم خبراؤنا في جافا سكريبت بدمج تطبيقاتك بسلاسة مع الخدمات الخارجية، واجهات برمجة التطبيقات، والمنصات، مما يضمن سير عمل سلس ووظائف محسّنة.",
        icon: "/images/hire-page-icons/hire-javascrip-icon6.svg",
      },
      {
        title: "حلول التجارة الإلكترونية بجافا سكريبت",
        description: "نحن نبني حلول تجارة إلكترونية عالية الأداء باستخدام جافا سكريبت، نقدم بوابات دفع آمنة، تصفحًا بديهيًا، وهندسة معمارية قابلة للتطوير لزيادة التحويلات.",
        icon: "/images/hire-page-icons/hire-javascrip-icon7.svg",
      },
      {
        title: "دعم وصيانة جافا سكريبت",
        description: "حافظ على تطبيق جافا سكريبت الخاص بك آمنًا ومُحسّنًا من خلال خدمات الدعم والصيانة المستمرة لدينا. نتعامل مع التحديثات، إصلاحات الأخطاء، وتحسينات الأداء.",
        icon: "/images/hire-page-icons/hire-javascrip-icon8.svg",
      },
    ],
  },

  // Why Choose Us (Development Performance)
  whyChooseUs: {
    btnText: "توظيف مطور اليوم",
    heading: "لماذا تختار Bitsclan لـ",
    greenHeading: "توظيف مطوري جافا سكريبت؟",
    subHeading: "في Bitsclan، نحن متخصصون في بناء تطبيقات عالية الأداء من خلال دمج جافا سكريبت مع تقنيات الواجهة الأمامية، الخلفية، والجوال الحديثة.",
    solutionsData: [
      {
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
        title: "الوصول إلى المواهب المعتمدة",
        description: "عندما توظف مطوري جافا سكريبت معنا، تحصل على وصول إلى محترفين تم فحصهم بالكامل لمهاراتهم وخبرتهم وطلاقتهم في اللغة الإنجليزية، مما يضمن قدرتهم على المساهمة بفعالية في مشروعك.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "عرض التطابقات في ثوانٍ",
        description: "انسَ تصفح مئات السير الذاتية! باستخدام نظام HireAI الخاص بنا، يمكنك العثور فورًا على مطوري جافا سكريبت للتوظيف ومطابقة المواهب المناسبة لمشروعك في بضع ثوانٍ فقط.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
        title: "وفر مع التوظيف العالمي",
        description: "من خلال التوظيف العالمي، يمكنك الوصول إلى أكثر من 450,000 محترف موهوب من 190 دولة. هذا يمكن أن يوفر لك ما يصل إلى 58% مقارنة بأساليب التوظيف التقليدية، مع الحصول على أفضل المطورين لخدمات تطوير جافا سكريبت الخاصة بك.",
        noBorder: true,
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
        title: "احصل على دعم بشري حقيقي",
        description: "في Bitsclan، لن نتركك وحدك. ستحصل على مساعدة شخصية من فريقنا من خبراء التوظيف لضمان توظيف مطور جافا سكريبت المناسب لاحتياجاتك.",
      },
    ],
  },

  // Technology Combinations
  techCombinations: {
    heading: "أفضل تركيبات جافا سكريبت لتطوير متميز",
    description: "أطلق العنان للإمكانات الكاملة لجافا سكريبت من خلال الاستفادة من تركيبات التكنولوجيا الأكثر فعالية. وظّف مطوري جافا سكريبت الخبراء لبناء حلول عالية الأداء وقابلة للتطوير ومبتكرة مصممة خصيصًا لاحتياجاتك.",
    combinations: [
      {
        title: "جافا سكريبت + React + Firebase",
        description: "جافا سكريبت كلغة أساسية، React لواجهة أمامية ديناميكية، و Firebase كقاعدة بيانات في الوقت الفعلي تساعد في بناء تطبيقات ويب تفاعلية ولا خادمية.",
        icons: ["javascript.svg", "react.svg", "firebase.png"],
      },
      {
        title: "جافا سكريبت + Angular + Node.js",
        description: "Angular في الواجهة الأمامية، Node.js كواجهة خلفية، وجافا سكريبت عبر المكدس تتيح تطويرًا فعالًا للمكدس الكامل للتطبيقات القابلة للتطوير.",
        icons: ["javascript.svg", "angular.svg", "nodejs.svg"],
      },
      {
        title: "جافا سكريبت + Vue.js + PostgreSQL",
        description: "Vue.js لواجهة أمامية خفيفة الوزن، منطق يعمل بجافا سكريبت، و PostgreSQL كقاعدة بيانات علائقية تضمن مكدس ويب متوازن وفعال.",
        icons: ["javascript.svg", "vue-js.svg", "postgres.svg"],
      },
      {
        title: "جافا سكريبت + Express.js + MongoDB",
        description: "Express.js كإطار عمل خفيف للواجهة الخلفية، جافا سكريبت للتعامل مع المنطق، و MongoDB كقاعدة بيانات NoSQL تنشئ حل ويب سريع ومرن.",
        icons: ["javascript.svg", "express.svg", "mongodb.svg"],
      },
    ],
  },

  // Hire Steps
  hireSteps: {
    btnText: "دعنا نجد المطور المثالي لك",
    heading: "وظّف مطوري جافا سكريبت في 4 خطوات سهلة",
    subHeading: "لم يكن توظيف مطوري جافا سكريبت الخبراء أسهل من أي وقت مضى. اتبع عمليتنا البسيطة المكونة من 4 خطوات للعثور على المطورين المثاليين لمشروعك.",
    steps: [
      {
        title: "اختر نموذج التعاقد الخاص بك",
        description: "اختر نموذج التعاقد الذي يناسبك سواء كان دوامًا كاملًا، أو دوامًا جزئيًا، أو بالساعة. نمنحك المرونة لاختيار ما يناسب مشروعك.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
      },
      {
        title: "فرز واختيار مطوري جافا سكريبت",
        description: "تصفح ملفات أفضل مطوري جافا سكريبت المتاحين للتوظيف. اختر أفضل المرشحين لمواصلة العملية.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
      },
      {
        title: "إجراء مقابلة فردية",
        description: "قابل المرشحين المختارين واختبر مهاراتهم بأسئلة نظرية وعملية. تساعد هذه الخطوة في ضمان حصولك على المرشح المناسب لمشروعك.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
      },
      {
        title: "مطورو جافا سكريبت",
        description: "بمجرد الانتهاء من اختيارك، سينضم مطور جافا سكريبت المختار إلى فريقك في غضون 24-48 ساعة، مستعدًا للبدء في العمل على مشروعك.",
        icon: "/images/hire-page-setps-icons/icon-4.svg",
      },
    ],
  },

  // Cover The Stack
  coverTheStack: {
    whereStart: "اللغات والأطر",
    mainHeading: "وظّف مطوري جافا سكريبت الخبراء لحلول الويب الديناميكية والقابلة للتطوير",
    subHeading: "في Bitsclan، ندعم رحلة تطوير الويب الخاصة بك بمكدس تقني حديث من جافا سكريبت يضمن التفاعل، قابلية التوسع، والأداء. يتخصص مطورو جافا سكريبت المهرة لدينا في بناء تطبيقات ويب متجاوبة وعالية الأداء مصممة خصيصًا لتلبية احتياجات عملك.",
    tabs: [
      "اللغات والأطر",
      "المكتبات",
      "أطر العمل",
    ],
    tabItems: [
      { tab: "اللغات والأطر", icon: "/images/tech-stack-icons/java.svg", name: "Java" },
      { tab: "اللغات والأطر", icon: "/images/tech-stack-icons/kotlin.svg", name: "Kotlin" },
      { tab: "اللغات والأطر", icon: "/images/tech-stack-icons/android-sdk.svg", name: "Android SDK" },
      { tab: "اللغات والأطر", icon: "/images/tech-stack-icons/jetpack-compose.svg", name: "Jetpack Compose" },
      { tab: "اللغات والأطر", icon: "/images/tech-stack-icons/android-jetpack.svg", name: "Android Jetpack" },
      { tab: "المكتبات", icon: "/images/tech-icon.svg", name: "PyTorch" },
      { tab: "المكتبات", icon: "/images/tech-icon2.svg", name: "Keras" },
      { tab: "المكتبات", icon: "/images/tech-icon3.svg", name: "MXNet" },
      { tab: "المكتبات", icon: "/images/libraries1.svg", name: "FastAI" },
      { tab: "المكتبات", icon: "/images/libraries2.svg", name: "TensorFlow" },
      { tab: "المكتبات", icon: "/images/libraries3.svg", name: "Theano" },
      { tab: "المكتبات", icon: "/images/libraries4.svg", name: "Scikit-learn" },
      { tab: "أطر العمل", icon: "/images/iconone.png", name: "Angular JS" },
      { tab: "أطر العمل", icon: "/images/node.svg", name: "Node JS" },
      { tab: "أطر العمل", icon: "/images/tech-stack-icons/vue-js.svg", name: "Vue.JS" },
      { tab: "أطر العمل", icon: "/images/database5.png", name: "Express JS" },
      { tab: "أطر العمل", icon: "database3.png", name: "Meteor JS" },
    ],
  },

  // Expert Facts
  expertFacts: {
    btnText: "حجز موعد",
    heading: "حقائق سريعة حول ",
    greenHeading: "فريق جافا سكريبت لدينا",
    facts: [
      { text: "أكثر من 40 مطور جافا سكريبت خبير جاهزون لبناء وتوسيع تطبيقاتك." },
      { text: "مطورون يتمتعون بخبرة تزيد عن 6 سنوات في تقنيات الواجهة الأمامية والخلفية لجافا سكريبت." },
      { text: "ماهرون في الأطر الحديثة مثل React.js، Vue.js، و Node.js لتطوير الويب الديناميكي." },
      { text: "خبرة في الحوسبة بلا خادم، تطوير السحابة الأصلية، وتكاملات واجهة برمجة التطبيقات." },
      { text: "بارعون في التقنيات الناشئة مثل الذكاء الاصطناعي، إنترنت الأشياء، وحلول البيانات الكبيرة." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-javascript-arabic.avif)`, // من mainBannerImg.factBackgroundImage
  },

  // App Idea Section
  appIdeaSection: {
    heading: "حوّل فكرة تطبيقك إلى نموذج عملي في أسابيع قليلة فقط!", // تمت الإضافة للاتساق
    content: "هل لديك فكرة ولكن لا تعرف من أين تبدأ؟ يمكن لخبراء جافا سكريبت لدينا مساعدتك في بناء نموذج عملي في أقل من 6-8 أسابيع! تحقق من رؤيتك، اختبر تفاعل المستخدمين، ووضع الأساس لإطلاق ناجح.",
  },

  // Engagement Models
  hirePageEngagementModels: {
    btnText: "ابدأ الآن",
    headingContent: [
      { text: "نماذج التعاقد" },
      { text: "المرنة لدينا" },
    ],
    discription: "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل، أو بدوام جزئي، أو بالساعة، فإننا نقدم خيارات مرنة لضمان التعاون السلس والحد الأقصى من الكفاءة طوال مشروعك.",
    hiringDetails: [
      {
        text: "توظيف بالساعة",
        hours: "48",
        timeUnit: "ساعة",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ العمل خلال "
      },
      {
        text: "توظيف بدوام كامل",
        hours: "72",
        timeUnit: "ساعة",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ العمل خلال "
      },
      {
        text: "توظيف بدوام جزئي",
        hours: "48",
        timeUnit: "ساعة",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ العمل خلال "
      },
    ],
  },

  // FAQ Section
  faqSection: {
    mainHeading: "الأسئلة المتداولة",
    subHeading: "استكشف خدمات تطوير جافا سكريبت لدينا للحصول على حلول ويب مخصصة، إنشاء واجهة برمجة تطبيقات، وإدارة النشر!",
    faqData: [
      {
        id: "collapseOne",
        question: "ما هي جافا سكريبت ولماذا يجب أن أستخدمها؟",
        answer: "جافا سكريبت هي لغة برمجة شائعة تستخدم لإنشاء صفحات ويب تفاعلية وديناميكية. تساعد في جعل مواقع الويب أكثر جاذبية من خلال السماح بميزات مثل الرسوم المتحركة، التحقق من صحة النماذج، والخرائط التفاعلية. إذا كنت تريد موقعًا إلكترونيًا أكثر من مجرد صفحات ثابتة، فإن جافا سكريبت خيار رائع.",
      },
      {
        id: "collapseTwo",
        question: "لماذا يجب أن أوظف مطوري جافا سكريبت؟",
        answer: "يضمن توظيف مطوري جافا سكريبت حصولك على خبراء يمكنهم بناء مواقع ويب أو تطبيقات ويب تفاعلية عالية الجودة. إنهم يعرفون كيفية جعل موقع الويب الخاص بك يعمل بسلاسة على أجهزة مختلفة، مما يوفر تجربة مستخدم أفضل.",
      },
      {
        id: "collapseThree",
        question: "كيف أعرف إذا كنت بحاجة إلى جافا سكريبت لمشروعي؟",
        answer: "إذا كنت تريد موقعًا إلكترونيًا ديناميكيًا يتفاعل مع المستخدمين، مثل النماذج، الرسوم المتحركة، أو التحديثات المباشرة، فإن جافا سكريبت ضرورية. كما أنها مفيدة لبناء تطبيقات ومواقع ويب تتطلب بيانات في الوقت الفعلي، مثل مواقع التجارة الإلكترونية أو منصات التواصل الاجتماعي.",
      },
      {
        id: "fourth",
        question: "كيف يمكنني توظيف أفضل مطوري جافا سكريبت؟",
        answer: "يمكنك توظيف مطوري جافا سكريبت من خلال البحث عن محترفين لديهم خبرة في بناء مواقع ويب تفاعلية وديناميكية. من المهم مراجعة مشاريعهم السابقة، والتحقق من مهاراتهم، والتأكد من فهمهم لأهداف مشروعك.",
      },
      {
        id: "fifth",
        question: "كم من الوقت يستغرق بناء تطبيق ويب بجافا سكريبت؟",
        answer: "يعتمد الوقت المستغرق لبناء تطبيق ويب بجافا سكريبت على مدى تعقيد المشروع. قد تستغرق مواقع الويب البسيطة بضعة أسابيع، بينما قد تستغرق تطبيقات الويب الأكثر تعقيدًا عدة أشهر. من المهم مناقشة الجداول الزمنية مع فريق التطوير الخاص بك.",
      },
      {
        id: "sixth",
        question: "ما هي فوائد توظيف مطوري جافا سكريبت من Bitsclan؟",
        answer: "في Bitsclan، لدينا مطورو جافا سكريبت ذوو خبرة للتوظيف وهم ماهرون في بناء تطبيقات ويب ديناميكية وعالية الأداء. نحن نضمن سرعة البدء، التواصل الواضح، وتقديم حلول تلبي احتياجات عملك.",
      },
    ],
  },
};